import styled from 'styled-components/macro';

type SectionSpacing = 'md' | 'lg';
type TitleAlign = 'left' | 'center';

type HomePageSectionProps = {
    title?: React.ReactNode;
    spacing?: SectionSpacing;
    titleAlign?: TitleAlign;
    className?: string;
    children: React.ReactNode;
};

const HomePageSection = ({
    title,
    spacing = 'md',
    titleAlign = 'left',
    className,
    children,
}: HomePageSectionProps) => (
    <Section $spacing={spacing} className={className}>
        {title && <SectionTitle $align={titleAlign}>{title}</SectionTitle>}
        {children}
    </Section>
);

const SPACING_TOP: Record<SectionSpacing, string> = {
    md: '64px',
    lg: '96px',
};

const Section = styled.section<{ $spacing: SectionSpacing }>`
    margin-top: ${({ $spacing }) => SPACING_TOP[$spacing]};

    &:last-child {
        margin-bottom: 64px;
    }
`;

const SectionTitle = styled.h2<{ $align: TitleAlign }>`
    font-size: 24px;
    font-weight: 700;
    margin: ${({ $align }) => ($align === 'center' ? '0 0 24px 0' : '0 0 0 12px')};
    text-align: ${({ $align }) => $align};
`;

export default HomePageSection;
